import { connect } from "react-redux";
import { compose } from "redux";
import {
  getChannelManagerList,
  getObjectById,
  setChannelManagerPage,
  setStatusStepByStep
} from "../../../globalState/object/actions";
import FastChooseCM from "./FastChooseCM";
import { updateSavingStatus } from "../../../globalState/app/actions";
import { getObjectsList } from "../../Objects/actions";


let mapStateToProps = (state) => {
  return {
    objectId: state.object.id,
    channelManagerList: state.object.channelManagers,
    channelManager: state.object.channelManager,
    firstRoom: state.object.rooms[0],
  }
};

export default compose(connect(mapStateToProps, {
  setChannelManagerPage,
  getChannelManagerList,
  updateSavingStatus,
  setStatusStepByStep,
  getObjectsList,
  getObjectById,
}))(FastChooseCM);




